<template>
    <div class="link-content-root">
        <div class="link-div">
            <div class="notice-title">
                <div class="title-left">
                    <span class="notice-title-left">友情链接</span>
                    <div class="title-bottom">
                        <div class="title-divider" style="border: 2px solid #3041A7;"></div>
                        <span class="bottom-text">Link</span>
                    </div>
                </div>
            </div>
            <div class="link-root draggable-container" ref="draggableContainer">
                <div class="draggable-img" v-for="(item,index) in linkList" :key="index">
                    <img draggable="false" :src="item.imgSrc" alt="" style="width:100%" @click="openLink(item.link)">
                </div>

            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            linkList: [
                {
                    imgSrc: "../../static/webp1/link1.png",
                    link: "https://www.ccgp.gov.cn/",
                },
                {
                    imgSrc: "../../static/webp1/link2.png",
                    link: "https://www.ccgp-anhui.gov.cn/",
                },
                {
                    imgSrc: "../../static/webp1/link3.png",
                    link: "https://jyt.ah.gov.cn/",
                },
                {
                    imgSrc: "../../static/webp1/link4.png",
                    link: "https://czt.ah.gov.cn/",
                },
                {
                    imgSrc: "../../static/webp1/link5.png",
                    link: "https://zbcg.mas.gov.cn/",
                },
                {
                    imgSrc: "../../static/webp1/link6.png",
                    link: "https://ggzy.hefei.gov.cn/",
                },
                {
                    imgSrc: "../../static/webp1/link7.jpg",
                    link: "https://www.ahtba.org.cn/",
                },
            ],
        };
    },
    methods: {
        openLink(link) {
            if (this.dragMoved) {
                return;
            }
            window.open(link, "_blank");
        },
    },
};
</script>

<style lang="less" scoped>
.link-content-root {
    padding: 30px 15%;
    width: 100%;
}
.link-root {
    display: flex;
    gap: 20px;
    overflow: hidden;
    user-select: none;
    width: 100%;
    .draggable-img {
        // width: 276px;
        flex: 1;
        // flex-shrink: 0;
        // min-width: 0;
        height: 100%;
        cursor: pointer;
    }
}
.notice-title {
    height: 55px;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
        display: flex;
        flex-direction: column;
        .notice-title-left {
            opacity: 0.89;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            font-size: 26px;
            color: #2947ac;
        }
        .title-bottom {
            display: flex;
            align-items: center;
            .title-divider {
                width: 28px;
                height: 1px;
                border: 2px solid #e8b138;
            }
            .bottom-text {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #2947ac;
                margin-left: 10px;
            }
        }
    }
    .notice-title-right {
        cursor: pointer;
        opacity: 0.89;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 16px;
        color: #2947ac;
        line-height: 24px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/link-list.vue